import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    income: {
        borderBottom: "10px solid #1e88e5",
    },
    expense: {
        borderBottom: "10px solid #ff0000"
    }
}));